module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/doctor/doctor.component.html
// module id = ./src/app/Pages/manage/doctor/doctor.component.html
// module chunks = main